// extracted by mini-css-extract-plugin
export default {"reportTextContainer":"_1-oS0","reportText":"_3nhIU"};